///<reference path="./ScrollObjectBase.ts"/>

namespace khi.bk117.view.parts.scroll
{
	import EventDispatcher = com.enirva.event.EventDispatcher;
	import Sprite = com.enirva.display.Sprite;
	import Tween = com.enirva.tween.Tween;
	
	import ScrollObjectBase = khi.bk117.view.parts.scroll.ScrollObjectBase;

	/*
	 * マスクオブジェクト(主にライン)
	 */
	export class MaskObject extends ScrollObjectBase
	{
		private delay:number;
		
		public force:boolean;

		public speed:number;

		constructor(target:JQuery, iniValue:number = 40)
		{
      super(target);
      
			this.delay = 0;
			this.speed = 0.01;
			this.force = false;

      const cls:string[] = target.attr("class").split(" ");
      for (var i:number = 0; i < cls.length; i++)
      {
        if (cls[i].indexOf("D_") >= 0)
        {
          this.delay = parseInt(cls[i].replace("D_", ""));
          //break;
				}
				else if (cls[i].indexOf("FORCE") >= 0)
				{
					this.force = true;
				}
				else if(cls[i].indexOf("SP_") >= 0)
				{
					this.speed = parseFloat(cls[i].replace("SP_", "")) / 1000;
				}
      }

      //this.spt.y = iniValue;
			this.spt.update();
			this.spt.element.css("height", "0%");
		}


		public update(curr:number, winH:number, isForce:boolean = false):void
		{
			if (!this.isShow)
			{
				if (this.force || ((curr + winH - this.showThresholdY) > this.offsetY))
				{
					this.isShow = true;
					//Tween.fadeIn(this.spt, 0.05);
					//Tween.motion(this.spt, ["y"], [0], this.speed, this.delay);
	
					let h:number = 0;
					let end:number = this.spt.element.find("span").height();
					let sa:number = 0;
					let tmp:number;
	
					//console.log("!!!!! " + this.offsetY);
	
					this.spt.onEnterFrame = ()=>
					{
						//console.log(h);
						sa += 0.005;
						h += tmp = (end - h) * sa;
						this.spt.element.css("height", h + "px");
	
						if (Math.abs(tmp) < 0.001)
						{
							this.spt.deleteEnterFrame;
							this.spt.element.css("height", "auto");
						}
					};
				}
			}
		}
	}
}

